import React from 'react';
import ReactDOM from 'react-dom';
import { PrincipalPage } from './components/PrincipalPage';
ReactDOM.render(
  <React.StrictMode>
    <PrincipalPage />
  </React.StrictMode>,
  document.getElementById('root')
);